module.exports = __webpack_public_path__ + "img/icon4.7e82c3c3.svg";